// © Microsoft Corporation. All rights reserved.

import { ConfigReference } from "@msnews/config-data-types";

export function getRootConfigRef(): ConfigReference  {
    return { experienceType: "AppConfig", instanceSrc: "default" };
}